export default "__VITE_ASSET__fb82a199__"